import type { AccountRole } from '~/types'
import { z } from 'zod'

/**
 * - Account Roles: Roles that can be assigned to accounts
 *
 * When adding a role, please
 *  - Add it to roles
 *  - Add the translation key to ~/locales/de.json and any other languages (role.ROLE_KEY)
 *  - Assign the roles to the correct groups at the bottom, to set their permissions in the backend
 *  - Adjust their frontend permissions in ~/authorization/permissions.ts
 *
 * Updated by:
 * - 10.09.26 https://github.com/sidestream-tech/dikoma/issues/1027
 */

export const accountRoles = z.enum([
  // Authenticated with supreme priviledges
  'admin',

  // Authenticated with some priviledges for kiso-infection-protection
  'infection-protection-manager',
  'infection-protection-specialist',
  'infection-protection-clerk',

  // Authenticated with some priviledges for kiso-heat-protection
  'heat-protection-clerk',
  'heat-protection-specialist',

  // Authenticated but without being a city employee
  'person',
  'institution',

  // No role
  'no-role',
])

export const heatProtectionRoles: AccountRole[] = ['admin', 'heat-protection-clerk', 'heat-protection-specialist']
export const infectionProtectionRoles: AccountRole[] = ['admin', 'infection-protection-manager', 'infection-protection-specialist', 'infection-protection-clerk']
export const cityRoles: AccountRole[] = [...infectionProtectionRoles, ...heatProtectionRoles]
